import { createTheme } from '@mui/material/styles';
const cssVar = (name) =>
    getComputedStyle(document.body).getPropertyValue(name).trim();

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#2A6DF4',
            contrastText: cssVar('--colorTitleSecondary'),
        },
        secondary: {
            main: cssVar('--colorTintPurple'),
        },
        background: {
            default: cssVar('--colorBackgroundPrimary'),
            paper: cssVar('--colorBackgroundPrimary'),
        },
        text: {
            primary: cssVar('--colorTitle'),
            secondary: cssVar('--colorSubtitle'),
        },
        error: {
            main: cssVar('--colorDestructive'),
        },
        success: {
            main: cssVar('--colorSuccess'),
        },
    },
});

export default darkTheme;
